export const environment = {
  production: false,
  brands: {
    enelx: {
      baseUrl: 'https://ops-stream.preprd-apps.enelx.com/v1/api',
      globalNavUrl: 'https://global-nav.preprd-svcs.enelx.net/api/v1',
    },
  },
  cdn: 'https://cdn.preprd-apps.enelx.com',
  defaults: {
    brand: 'enelx',
    locale: 'en-us',
    apiLocale: 'en_US',
  },
};
